export function hasExplicitParentUrlFromBootScript(script: HTMLScriptElement): boolean {
  return new URL(script.src).searchParams.has('parentUrl')
}

export function resolveParentUrlFromBootScript(script: HTMLScriptElement): string | undefined {
  const scriptParams = new URL(script.src).searchParams
  const explicit = scriptParams.get('parentUrl')
  const isFromPreview = scriptParams.get('fromPreview') === 'true'
  if (explicit) return explicit
  if (isFromPreview) return undefined
  return window.location.href
}
